import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import Botox from './components/services/Botox';
import ChemicalPeels from './components/services/ChemicalPeels';
import DermalFillers from './components/services/DermalFillers';
import LaserHairRemoval from './components/services/LaserHairRemoval';
import HairRestoration from './components/services/HairRestoration';
import HydraFacial from './components/services/Hydrafacial';
import MedicalWeightLoss from './components/services/MedicalWeightLoss';
import Microneedling from './components/services/Microneedling';
import VascularLesion from './components/services/VascularLesion';
import PigmentedLesion from './components/services/PigmentedLesion';
import SkinRevitalization from './components/services/SkinRevitalization';
import AboutUs from './components/AboutUs';
import IVTherapy from './components/services/IVTherapy';
import FAQ from './components/FAQ';
import GoogleReviews from './components/GoogleReviews';
import Injectables from './components/services/Injectables';
import Facials from './components/services/Facials';
import BodyTreatments from './components/services/BodyTreatments';
import MensHealth from './components/services/MensHealth';
import Peptides from './components/services/Peptides';
import MuscleSculpting from './components/services/MuscleSculpting';
import Massage from './components/services/Massage';
import Waxing from './components/services/Waxing';
import LocationMap from './components/LocationMap';
import SkinTag from './components/services/SkinTag';
import ExclusiveMemberships from './components/memberships/ExclusiveMemberships';
import MensMemberships from './components/memberships/MensMemberships';
import PrivacyPolicy from './components/PrivacyPolicy';
import ReactGA from 'react-ga4';
ReactGA.initialize('G-20D66NWHPN');

// Home Page Component with SEO
function HomePage() {
  return (
    <>
      <Helmet>
        <title>Century Longevity & Aesthetics | Premier Medical Spa & Wellness Center</title>
        <meta name="description" content="Experience transformative beauty and wellness treatments at Century Longevity & Aesthetics. Offering Botox, fillers, laser treatments, HydraFacials, IV therapy, and more." />
        <meta name="keywords" content="medical spa, aesthetics, botox, dermal fillers, hydrafacial, laser hair removal, IV therapy, wellness center, anti-aging treatments" />
        <link rel="canonical" href="https://www.centuryaesthetics.org/" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Century Longevity & Aesthetics | Premier Medical Spa" />
        <meta property="og:description" content="Transform your beauty and wellness journey with expert aesthetic treatments and longevity services." />
        <meta property="og:url" content="https://www.centuryaesthetics.org/" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Hero />
      <Services />
      <Testimonials />
      <ContactForm />
      <LocationMap/>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/botox" element={<Botox />} />
            <Route path="/chemical-peels" element={<ChemicalPeels />} />
            <Route path="/dermal-fillers" element={<DermalFillers />} />
            <Route path="/laser-hair-removal" element={<LaserHairRemoval />} />
            <Route path="/hair-restoration" element={<HairRestoration />} />
            <Route path="/hydrafacial" element={<HydraFacial />} />
            <Route path="/medical-weight" element={<MedicalWeightLoss />} />
            <Route path="/microneedling" element={<Microneedling />} />
            <Route path="/pigmented-lesion" element={<PigmentedLesion />} />
            <Route path="/vascular-lesion" element={<VascularLesion />} />
            <Route path="/skin-revitalization" element={<SkinRevitalization />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/iv-therapy" element={<IVTherapy />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/google-reviews" element={<GoogleReviews />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/injectables" element={<Injectables />} />
            <Route path="/facials" element={<Facials />} />
            <Route path="/body-treatments" element={<BodyTreatments />} />
            <Route path="/mens-health" element={<MensHealth />} />
            <Route path="/peptides" element={<Peptides />} />
            <Route path="/muscle-sculpting" element={<MuscleSculpting />} />
            <Route path="/massage" element={<Massage />} />
            <Route path="/waxing" element={<Waxing />} />
            <Route path="/skin-tag" element={<SkinTag />} />
            <Route path="/exclusive-memberships" element={<ExclusiveMemberships />} />
            <Route path="/mens-memberships" element={<MensMemberships />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;